import { render, staticRenderFns } from "./AddAttachments.vue?vue&type=template&id=62652c1f"
import script from "./AddAttachments.vue?vue&type=script&lang=js"
export * from "./AddAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports